import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { TimezoneInput } from "@/lib/Components/Form/Inputs/TimezoneInput";
import { SwitchInput } from "@/lib/Components/Form/Inputs/SwitchInput";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";

export function SupplierLineSoldForm() {
  const { values } = useFormState();

  return (
    <>
      <SwitchInput
        name="email_on_line_sold"
        label="Email on plate sold"
        tooltip="Should the supplier recieve an email when the plate is reserved"
      />

      {values.email_on_line_sold ? (
        <>
          <TextInput
            name="line_sold_email"
            label="Plate sold email"
            tooltip="The email the plate sold emails will be sent too"
            type="email"
          />
          <TimezoneInput name="line_sold_timezone" label="Timezone" />

          <TextInput
            name="relocation_lines_valid_until"
            label="Email until"
            type="time"
          />
        </>
      ) : null}
    </>
  );
}
